<template>
  <div>
    <new-permission :toggle="show_new_permission" @created="retrieve" />
    <view-permission
      :toggle="show_view_permission"
      :permission_id="view_permission_id"
      @updated="retrieve"
    />
    <v-row>
      <errors-messages :errors="errors" />
      <v-col cols="auto">
        <v-btn
          color="primary"
          @click="show_new_permission = !show_new_permission"
        >
          <v-icon class="mr-1">mdi-plus</v-icon>
          NOVA PERMISSÃO
        </v-btn>
      </v-col>
      <v-col>
        <v-text-field
          v-model="search"
          placeholder="Procurar"
          append-icon="mdi-magnify"
          single-line
          hide-details
          class="m-0 p-0"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          dense
          :search="search"
          locale="pt-BR"
          no-data-text="Nenhuma permissão cadastrada"
          no-results-text="Nenhuma permissão coincide com os filtros"
          :loading="loading"
          :headers="headers"
          :items="permissions"
          group-by="group_name"
          @click:row="openViewModal"
        >
          <template
            v-slot:[`group.header`]="{ group, headers, toggle, isOpen }"
          >
            <td :colspan="headers.length" @click="toggle">
              <v-btn x-small icon :ref="group">
                <v-icon v-if="isOpen">mdi-plus</v-icon>
                <v-icon v-else>mdi-minus</v-icon>
              </v-btn>
              <span class="mx-2">{{ group.toUpperCase() }}</span>
            </td>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <template v-for="(action, index) in item.actions">
              <span :key="action.id">
                {{
                  `${
                    index == item.actions.length - 1
                      ? action.name
                      : `${action.name}, `
                  }`
                }}
              </span>
            </template>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from "../../services/api";
import ErrorsMessages from "../components/ErrorsMessages.vue";
import NewPermission from "./NewPermission.vue";
import ViewPermission from "./ViewPermission.vue";

export default {
  components: {
    ErrorsMessages,
    NewPermission,
    ViewPermission,
  },
  name: "Permissions",
  data: () => ({
    errors: [],
    loading: false,

    search: "",
    headers: [
      { text: "Código", value: "id" },
      { text: "Nome", value: "name" },
      { text: "Target", value: "target" },
      { text: "Ações", value: "actions" },
    ],
    permissions: [],

    show_new_permission: false,

    show_view_permission: false,
    view_permission_id: "",
  }),
  created() {
    this.retrieve();
  },
  methods: {
    async retrieve() {
      this.loading = true;

      try {
        const response = await api.get("/admin/rest-home/default/permissions");
        const { error, errors, permissions } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.permissions = permissions;
        }
      } catch (error) {
        console.log(error);
      }

      this.loading = false;
    },

    async openViewModal(item) {
      this.view_permission_id = item.id;
      this.show_view_permission = !this.show_view_permission;
    },
  },
};
</script>

<style>
</style>